document.addEventListener('DOMContentLoaded', (event) => {
    
    window.onscroll = function(e) {

        // add scrolling direction class to html element
        if (this.oldScroll > this.scrollY) {
            //up 
            document.documentElement.classList.add('scrolling-up');
            document.documentElement.classList.remove('scrolling-down');
        } else {
            //down
            document.documentElement.classList.add('scrolling-down');
            document.documentElement.classList.remove('scrolling-up');
        };
        
        // add below-fold (one screen height scrolled) info class to html element
        if (this.scrollY > window.innerHeight) {
            document.documentElement.classList.add('below-fold');
        } else {
            document.documentElement.classList.remove('below-fold');
        };
        
        //save old value
        this.oldScroll = this.scrollY;
    };

    
    // mobile hover - hover on intersection
    const observedElements = document.querySelectorAll('.intersection-observe');
    const obsMaxWidth = 480;

    if (observedElements.length && screen.width <= obsMaxWidth){
        const toggleActive = (entries, observer) => {
            entries.forEach((entry) => {
                // verify the element is intersecting
                if(entry.isIntersecting && entry.intersectionRatio >= 0.9) {
                    entry.target.classList.add('active');
                } else {
                    entry.target.classList.remove('active');
                };
            });
        };
        
        // init the observer
        const options = {
            threshold: 0.9
        };
        const observer = new IntersectionObserver(toggleActive, options);
        
        // target the elements to be observed
        
        observedElements.forEach((el) => {
            observer.observe(el);
        });

    } else {
        console.info('no obs el');
    };
    
});

